import styled from "styled-components";
import css from "@styled-system/css";
import { Link } from "gatsby";

export const Wrapper = styled(Link)`
  align-items: center;
  background-position: 50% 50%;
  background-size: cover;
  display: flex;
  justify-content: center;
  min-height: 50vh;
  width: 100%;

  ${({ image }) =>
    css({
      backgroundImage: `url(${image})`,
      color: "textSecondary",
    })}

  h1 {
    ${css({
      color: "textSecondary",
    })}
  }

  p {
    text-transform: uppercase;

    ${css({
      fontSize: [0],
    })}
  }
`;

export const Overlay = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 50vh;
  width: 100%;

  ${css({
    backgroundColor: "overlay",
  })}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  width: 100%;

  ${css({
    padding: [3],
  })}
`;

export const Button = styled.span`
  align-self: flex-start;
  text-transform: uppercase;

  ${css({
    backgroundColor: "primary",
    color: "textSecondary",
    fontFamily: "heading",
    padding: [1],
  })}
`;
